import request from '@/utils/request';

export function getShopApplyPage(query) {
  return request({
    url: '/api/system/shopApply/queryShopApplyPage',
    method: 'post',
    data: query
  });
}

export function getShopApplyList(query) {
  return request({
    url: '/api/system/shopApply/queryShopApplyList',
    method: 'post',
    data: query
  });
}

export function getShopApply(query) {
  return request({
    url: '/api/system/shopApply/getShopApply',
    method: 'post',
    data: query
  });
}

export function updateShopApply(form) {
  return request({
    url: '/api/system/shopApply/updateShopApply',
    method: 'post',
    data: form
  });
}

export function saveShopApply(form) {
  return request({
    url: '/api/system/shopApply/saveShopApply',
    method: 'post',
    data: form
  });
}

export function deleteShopApply(id) {
  return request({
    url: '/api/system/shopApply/deleteShopApply',
    method: 'post',
    data: {'id': id}
  });
}

export function audit(form) {
  return request({
    url: '/api/system/shopApply/audit',
    method: 'post',
    data: form
  });
}

export function noAudit(form) {
  return request({
    url: '/api/system/shopApply/noAudit',
    method: 'post',
    data: form
  });
}



// WEBPACK FOOTER //
// ./src/api/apply.js